import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-user-stop-impersonating',
		path: '/admin/u/stop_impersonating',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_user_stop_impersonating" */ './index'), {
			exportName: 'AdminUserStopImpersonating',
			fallback: Loading,
		}),
		priority: 10,
		// no role check as we might be impersonating someone and therefore not staff...
		frame: true,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
